import { createFileRoute } from "@tanstack/react-router";
import { VerifyMethod } from "../../pages/Auth/VerifyMethod";
import { requireAuth } from "../../utils/routeGuards";

export const Route = createFileRoute("/auth/verify-method")({
  beforeLoad: ({ location }) => requireAuth(location),
  component: VerifyMethod,
});
